
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useLeagueRewardEdit } from '@/modules/league/tier/reward/model/edit';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';

export default defineComponent({
    name: ROUTE_NAME_LEAGUE.TIER.REWARD.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, update } = useLeagueRewardEdit();

        onMounted(() => fetch());

        return { v$, model, fetch, update };
    }
});
